import { Button, Tile } from '@Components/common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './BankDetailsForm.module.scss';
import classNames from 'classnames';

export const BankDetails = ({
  accountNumber,
  sortCode,
  accountName,
  setDisplayBankDetailsForm,
  onSave,
}: {
  accountNumber: string;
  sortCode: string;
  accountName: string;
  setDisplayBankDetailsForm: (openForm: boolean) => void;
  onSave?: () => void;
}) => {
  const { t } = useTranslation('account');

  return (
    <>
      <Tile
        title={{
          title: t('tabs.bank_details.current_bank_details'),
          subtitle: t('tabs.bank_details.current_bank_details_description'),
        }}
        className={classNames(styles.bankDetailsTile)}
      >
        <div className={styles.bankDetailsContainer}>
          <p className={styles.bankDetails}>
            <strong>{t('tabs.bank_details.account_name')}</strong> <span>{accountName}</span>
          </p>
          <p className={styles.bankDetails}>
            <strong>{t('tabs.bank_details.account_number')}</strong> <span>{accountNumber}</span>
          </p>
          <p className={styles.bankDetails}>
            <strong>{t('tabs.bank_details.sort_code')}</strong> <span>{sortCode}</span>
          </p>
        </div>
      </Tile>
      <div className={styles.buttonContainer}>
        <Button
          buttonType={!onSave ? 'primary' : 'tertiary'}
          className={styles.button}
          onClick={() => setDisplayBankDetailsForm(true)}
        >
          {t('tabs.bank_details.update_bank_details')}
        </Button>
        {onSave && (
          <Button buttonType="primary" className={styles.button} onClick={() => onSave && onSave()}>
            {t('save')}
          </Button>
        )}
      </div>
    </>
  );
};
